/* @flow */

import Immutable from 'immutable';
import ObjectPath from 'object-path';
import hat from 'hat';
import { asyncWrapper } from './async';
import { MapConstants } from '../constants/map_constants';
import { MapSelectors } from '../stores/map_selectors';
import { DatasetSelectors } from '../stores/dataset_selectors';
import { DatasetActionCreators } from '../stores/dataset_action_creators';
import * as APIClient from '../util/api_client';

var MapActionCreators = {
  setViewport: function(viewport: immutable.map): object {
    return {
      type: MapConstants.MAP_SET_VIEWPORT,
      viewport
    }
  },
  setMarkerHoverId: function(hoverId: number): Object {
    return {
      type: MapConstants.MAP_SET_MARKER_HOVER,
      hoverId
    }
  },
  setPopup: function(longitude: number, latitude: number, feature: object): object {
    return {
      type: MapConstants.MAP_SET_POPUP,
      longitude,
      latitude,
      feature
    }
  },
  setPopupFromClick: function(longitude: number, latitude: number, feature: object): Function {
    return (dispatch, getState) => {
      if (feature.dataset) {
        //try to replace the feature with the one in our datasets
        const dataset = DatasetSelectors.getDataset(getState(), feature.dataset.ownerId, feature.dataset.datasetId);
        if (dataset && dataset.has('features')) {
          const lookupVal = ObjectPath.get(feature, feature.dataset.vectorPath);
          const matched = dataset.get('features').filter(function(record) {
            return (ObjectPath.get(record, feature.dataset.datasetPath) == lookupVal);
          });

          if(matched[0] && matched[0].properties) {
            feature = matched[0];
          }
        }
      }

      dispatch({
        type: MapConstants.MAP_SET_POPUP,
        longitude,
        latitude,
        feature
      });
    }
  },
  clearPopup: function(): object {
    return {
      type: MapConstants.MAP_CLEAR_POPUP
    }
  },
  addAction: function(type: string, params: object): object {
    const id = hat();
    return {
      type: MapConstants.MAP_ADD_ACTION,
      id,
      actionType: type,
      params
    }
  },
  deleteActions: function(ids: Array<string>): object {
    return {
      type: MapConstants.MAP_DELETE_ACTIONS,
      ids
    }
  },
};

export { MapActionCreators };
